import LoginPage from "../containers/LoginPage";
export default function Login() {
    return <LoginPage slug={"login"}/>
}
